import type { Country } from '@faceup/utils'
import * as Flags from 'country-flag-icons/react/3x2'

export const CountryFlag = ({ country }: { country: Country }) => {
  // biome-ignore lint/performance/noDynamicNamespaceImportAccess: Country code is dynamic, static import not feasible
  const Flag = Flags[country.toUpperCase() as keyof typeof Flags]

  return (
    <Flag
      style={{
        width: 24,
        height: 16,
        borderRadius: 2,
        display: 'flex',
      }}
    />
  )
}
